var _circle, _path, _line, _line2, _line3, _path2, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4ChSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 42 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 100.33,
    r: 25,
    fill: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.65,102S73.36,32.22,78.79,23.3,90.2,10.77,96,10.77h94.13",
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 174.04,
    y1: 148.14,
    x2: 174.04,
    y2: 52.53,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 174.04,
    y1: 52.86,
    x2: 133.86,
    y2: 119.64,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 133.86,
    y1: 119.64,
    x2: 189.45,
    y2: 119.64,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.65,99.33S73.36,169.11,78.79,178,90.2,190.57,96,190.57h94.13",
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 75.02,
    y1: 82.5,
    x2: 110.02,
    y2: 117.5,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 75.02,
    y1: 117.5,
    x2: 110.02,
    y2: 82.5,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4ChSmall);
export default __webpack_public_path__ + "static/media/4Ch_Small.7d59783eba171a9adeb950a2229b9c4a.svg";
export { ForwardRef as ReactComponent };